import      React               from "react";
import      Style               from "components/UI/main.module.scss";
import {    GetBusinessLabel }  from "Utilities/utils";

export const AccessDeniedContent = () => {
    return (
        <React.Fragment>
            <div   className={[Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.mx_3].join(" ")}>
                <svg    
                        style={{width: "4.0rem", height: "auto"}}
                        className={Style.sv_theme_color}
                        viewBox="0 0 32 32" 
                        xmlns="http://www.w3.org/2000/svg"
                >
                    <g> 
                        <path d="M0 26.016v-20q0-2.496 1.76-4.256t4.256-1.76h20q2.464 0 4.224 1.76t1.76 4.256v20q0 2.496-1.76 4.224t-4.224 1.76h-20q-2.496 0-4.256-1.76t-1.76-4.224zM4 26.016q0 0.832 0.576 1.408t1.44 0.576h20q0.8 0 1.408-0.576t0.576-1.408v-14.016h-24v14.016zM4 10.016h24v-4q0-0.832-0.576-1.408t-1.408-0.608h-20q-0.832 0-1.44 0.608t-0.576 1.408v4zM6.016 8v-1.984h1.984v1.984h-1.984zM10.016 8v-1.984h1.984v1.984h-1.984zM10.336 22.848l2.848-2.848-2.848-2.816 2.848-2.816 2.816 2.816 2.816-2.816 2.848 2.816-2.848 2.816 2.848 2.848-2.848 2.816-2.816-2.816-2.816 2.816zM14.016 8v-1.984h12v1.984h-12z"/> 
                    </g>
                </svg>
                <span   className={[Style.text_body, Style.fs_8, Style.fw_semibold, Style.mx_3, Style.text_wrap].join(" ")}>
                    {GetBusinessLabel("AccessDeniedContent")}
                </span>
            </div>
        </React.Fragment>
    );
};